import React from 'react'

const Divider = () => {
  return (
    <div className='w-full bg-[#DEE2E6] h-[0.5px]'></div>
  )
}

export default Divider